import React, { useEffect, useState } from 'react';

const useShowFullView = () => {
    const localStorageKey = 'customer_view_toggled';

    const [customerViewToggled, setIsFullViewToggled] = useState(false);

    useEffect(() => {
        const storedValue = localStorage.getItem(localStorageKey);
        setIsFullViewToggled(storedValue ? storedValue === 'true' : false);
    }, []);

    const toggleFullView = () => {
        const newValue = !customerViewToggled;
        localStorage.setItem(localStorageKey, JSON.stringify(newValue));
        setIsFullViewToggled(newValue);
    };

    return { customerViewToggled, toggleFullView };
};

export const CustomerModeContext = React.createContext({
    customerViewToggled: false,
    toggleFullView: () => {},
});

type Props = {
    children: React.ReactNode | React.ReactNode[];
};

export const CustomerModeProvider: React.FC<Props> = ({ children }) => {
    const fullView = useShowFullView();

    return <CustomerModeContext.Provider value={fullView}>{children}</CustomerModeContext.Provider>;
};

export const useCustomerMode = () => {
    return React.useContext(CustomerModeContext);
};
